// Откуда открыли гайд (мини-спринт C, §3.4).
// Source: docs/specs/design-revision/c-onboarding.md §3.4.
//
// Гайд — обычный роут: на него можно попасть по прямой ссылке, обновить
// страницу, вернуться из истории браузера. Без явного контракта «возврат
// туда, откуда открыли» не реализуется стабильно.
//
// Приём тот же, что у markerNavState: значение живёт в модуле, а не в URL.

/**
 * Список источников закрытый, а не любой путь.
 *
 * Открытый список означал бы, что в него можно подсунуть что угодно, включая
 * внешний адрес: гайд отдаёт это значение прямо в навигацию.
 */
const ALLOWED = ['/', '/profile'] as const;

export type GuideOrigin = (typeof ALLOWED)[number];

const FALLBACK: GuideOrigin = '/';

let origin: GuideOrigin | null = null;

export function setGuideOrigin(path: string): void {
  origin = (ALLOWED as readonly string[]).includes(path) ? (path as GuideOrigin) : FALLBACK;
}

/**
 * Куда возвращаться. Идемпотентно: прямой заход и обновление страницы дают
 * `/` — на этот момент модуль перезагружен и значения в нём уже нет.
 */
export function readGuideOrigin(): GuideOrigin {
  return origin ?? FALLBACK;
}

/** Сброс после выхода из гайда, чтобы следующий заход не унаследовал чужой источник. */
export function clearGuideOrigin(): void {
  origin = null;
}
